<template>
    <div>
        <span>{{ value }} h</span>
    </div>
</template>

<script>
export default {
    name: 'CategoryHourUnit',
    props: {
        value: { type: String, required: true },
    },
};
</script>
